import { MetaService } from 'app/services/meta.service';
import { Component } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { FragmentService } from '../../services/fragment.service';

@Component({
    selector: 'app-basic',
    templateUrl: './basic.component.html',
    styleUrls: ['./basic.component.scss'],
    standalone: false
})
export class BasicComponent extends BaseComponent {
  constructor(
    public fragmentService: FragmentService,
    public metaService: MetaService
  ) {
    super(fragmentService, metaService);
  }
}
